import React from 'react';
import { useSelector } from 'react-redux';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import { productTypes } from 'appConstants';

export default function WithLDUser({ children }) {
  const { user } = useSelector((state) => state);
  const ldClient = useLDClient();

  React.useEffect(
    () => {
      if (user.authenticated && user.customerIds.length) {
        const [textRecruitCustomer] = user.customerIds.filter(
          (c) => c.product === productTypes.TEXT_RECRUIT,
        );
        ldClient.identify({
          key: user.userName,
          firstName: user.firstName,
          lastName: user.lastName,
          custom: {
            customerId: textRecruitCustomer.customerId,
          },
        });
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user.customerIds],
  );
  return children;
}
